import SectionTitle from '../../components/SectionTitle/SectionTitle';
import FormularioCarga from './components/FormularioCarga';
import UploadingComponent from './components/UploadingComponent';
import useCargaDocumentos from './hooks/useCargaDocumentos';

function CargaDocumentos() {
    const { uploadingDocument, ...props } = useCargaDocumentos();

    return (
        <>
            <SectionTitle title="Guardado de Documentación Digital" />

            <FormularioCarga {...props} />

            <UploadingComponent open={uploadingDocument} />
        </>
    );
}

export default CargaDocumentos;
